export const RAIL_DOCK_MAX_WIDTH = 1440;
export const RAIL_DOCK_HYSTERESIS = 32;

/** Dock below 1440, stay docked until width clears 1440+hysteresis so ResizeObserver cannot flip-flop. */
export function nextRailDock(width: number, currentlyDocked: boolean, maxWidth = RAIL_DOCK_MAX_WIDTH, hysteresis = RAIL_DOCK_HYSTERESIS): boolean {

  return currentlyDocked ? width <= maxWidth + hysteresis : width <= maxWidth;
}
